import { createHeaderLogo, LogoProps } from './createHeaderLogo'
import { StyledImageLogo } from '../TheWestHeader.styled'

const logoFile = require('./images/masthead-narrogin-observer.svg')

const props: LogoProps = {
    alt: 'Narrogin Observer',
    src: logoFile,
    heights: {
        desktop: 82,
        tablet: 70,
        mobile: 50,
    },
    ampInitialSize: {
        width: 618,
        height: 92,
    },
    verticalSpacing: 6,
}

export default createHeaderLogo(StyledImageLogo, props)
